import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';
import DisclaimerContent from './DisclaimerContent.jsx';
import {
	FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE,
	FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE,
	EST_LEASE_DISCLAIMER_HEADING,
	EST_FINANCE_DISCLAIMER_HEADING
} from '../constants/labels';
import { getDisclaimerPlaceholderObj } from '../utils/utility';

const DisclaimersModal = props => {
	const { isModalVisible, handleClose, paymentInfo } = props;

	if (!paymentInfo) {
		return null;
	}
	let modalBody = '';
	let title = '';
	const { _type, dealershipName } = paymentInfo;
	const placeholderValuesObj = getDisclaimerPlaceholderObj(paymentInfo);

	if (_type === 'LOAN') {
		title = (
			<Common
				render={({ labels }) => {
					return labels.get(EST_FINANCE_DISCLAIMER_HEADING);
				}}
			/>
		);
		modalBody = (
			<DisclaimerContent
				placeholderValuesObj={placeholderValuesObj}
				disclaimerLabel={
					FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE
				}
				dealershipName={dealershipName}
			/>
		);
	}

	if (_type === 'LEASE') {
		title = (
			<Common
				render={({ labels }) => {
					return labels.get(EST_LEASE_DISCLAIMER_HEADING);
				}}
			/>
		);
		modalBody = (
			<DisclaimerContent
				placeholderValuesObj={placeholderValuesObj}
				disclaimerLabel={FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE}
				dealershipName={dealershipName}
			/>
		);
	}
	return (
		<Modal show={isModalVisible} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title className="text-center">
					<span className="h3 font-weight-bold">{title}</span>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>{modalBody}</Modal.Body>
		</Modal>
	);
};

DisclaimersModal.defaultProps = {
	paymentInfo: null
};

DisclaimersModal.propTypes = {
	isModalVisible: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	paymentInfo: PropTypes.shape()
};

export default DisclaimersModal;



// WEBPACK FOOTER //
// ./src/components/DisclaimersModal.jsx